import { cryptoApi } from '../../service/cryptopay-api';
import { notificationsSuccessShow, notificationsErrorShow } from './notifications';

// CONSTANTS
export const MERCHANT_DATA_GET = 'MERCHANT_DATA_GET';
export const MERCHANT_DATA_SET = 'MERCHANT_DATA_SET';
export const MERCHANT_DATA_EDIT = 'MERCHANT_DATA_EDIT';
export const MERCHANT_BALANCES_GET = 'MERCHANT_BALANCES_GET';
export const MERCHANT_BALANCES_SET = 'MERCHANT_BALANCES_SET';
export const MERCHANT_DATA_ERROR = 'MERCHANT_DATA_ERROR';
export const GET_MERCHANT_API_KEYS_REQUEST = 'GET_MERCHANT_API_KEYS_REQUEST';
export const GET_MERCHANT_API_KEYS_SUCCESS = 'GET_MERCHANT_API_KEYS_SUCCESS';
export const GET_MERCHANT_API_KEYS_FAIL = 'GET_MERCHANT_API_KEYS_FAIL';

export const GET_API_SET_APP_TWO_FA = 'GET_API_SET_APP_TWO_FA';
export const GET_API_SET_EMAIL_TWO_FA = 'GET_API_SET_EMAIL_TWO_FA';
export const GET_API_SET_PHONE_TWO_FA = 'GET_API_SET_PHONE_TWO_FA';
export const GET_API_RESET_TWO_FA = 'GET_API_RESET_TWO_FA';

export const GET_WEBHOOKS_LIST_REQUEST = 'GET_WEBHOOKS_LIST_REQUEST';
export const GET_WEBHOOKS_LIST_SUCCESS = 'GET_WEBHOOKS_LIST_SUCCESS';
export const GET_WEBHOOKS_LIST_FAIL = 'GET_WEBHOOKS_LIST_FAIL';

export const getApiSetAppTwoFa = isAppTwoFa => ({
  type: GET_API_SET_APP_TWO_FA,
  isAppTwoFa,
});

export const getApiSetEmailTwoFa = isEmailTwoFa => ({
  type: GET_API_SET_EMAIL_TWO_FA,
  isEmailTwoFa,
});

export const getApiSetPhoneTwoFa = isPhoneTwoFa => ({
  type: GET_API_SET_PHONE_TWO_FA,
  isPhoneTwoFa,
});

export const getApiResetTwoFa = () => ({
  type: GET_API_RESET_TWO_FA,
});

// ACTIONS GENERATORS
export const merchantDataGet = () => ({
  type: MERCHANT_DATA_GET,
  fetching: true,
});

export const merchantDataSet = data => ({
  type: MERCHANT_DATA_SET,
  fetching: false,
  payload: data,
});

export const merchantDataEdit = () => ({
  type: MERCHANT_DATA_EDIT,
  fetching: true,
});

export const merchantBalancesGet = () => ({
  type: MERCHANT_BALANCES_GET,
  fetching: true,
});

export const merchantBalancesSet = data => ({
  type: MERCHANT_BALANCES_SET,
  fetching: false,
  payload: data,
});

export const merchantDataError = () => ({
  type: MERCHANT_DATA_ERROR,
});

export const getMerchantApiKeysRequest = () => ({
  type: GET_MERCHANT_API_KEYS_REQUEST,
  fetching: true,
});

export const getMerchantApiKeysSuccess = data => ({
  type: GET_MERCHANT_API_KEYS_SUCCESS,
  payload: data,
  fetching: false,
});

export const getMerchantApiKeysFail = () => ({
  type: GET_MERCHANT_API_KEYS_FAIL,
});

// ASYNC ACTIONS
export const getMerchantData = dispatch => async (merchantId, userId) => {
  dispatch(merchantDataGet());
  let merchantData;

  try {
    merchantData = await cryptoApi.getMerchantData(merchantId, userId);
  } catch (err) {
    dispatch(merchantDataError());
    dispatch(notificationsErrorShow(err.data));
  }

  if (merchantData && merchantData.data) {
    dispatch(merchantDataSet({ ...merchantData.data }));
    return;
  }

  dispatch(merchantDataError());
};

export const editMerchantData = dispatch => async (merchantId, body) => {
  dispatch(merchantDataEdit());
  let merchantData;

  try {
    merchantData = await cryptoApi.editMerchantData(merchantId, body);
  } catch (err) {
    dispatch(merchantDataError());
    dispatch(notificationsErrorShow(err.data || err));
  }

  if (merchantData && merchantData.data) {
    dispatch(merchantDataSet({ ...merchantData.data }));
    dispatch(notificationsSuccessShow({}));
    return;
  }

  dispatch(merchantDataError());
};

export const getMerchantBalances =
  dispatch =>
  async (merchantId, networkFilter, positiveBalance = false, fromSockets = false, walletVersion) => {
    !fromSockets && dispatch(merchantBalancesGet());
    let merchantBalances;
    const effectiveWalletVersion = walletVersion || localStorage.getItem('walletVersion') || undefined;

    try {
      merchantBalances = await cryptoApi.getMerchantBalances(
        merchantId,
        networkFilter,
        positiveBalance,
        effectiveWalletVersion
      );
    } catch (err) {
      dispatch(merchantDataError());
      dispatch(notificationsErrorShow(err.data));
    }

    if (merchantBalances && merchantBalances.data) {
      dispatch(merchantBalancesSet(merchantBalances.data));
      return;
    }

    dispatch(merchantDataError());
  };

export const getMerchantApiKeys = dispatch => async (merchantId, emailTwoFaCode, appTwoFaCode, verifyCode) => {
  dispatch(getMerchantApiKeysRequest());
  let response;

  try {
    response = await cryptoApi.getMerchantApiKeys(merchantId, emailTwoFaCode, appTwoFaCode, verifyCode);
  } catch (err) {
    dispatch(getMerchantApiKeysFail());
    dispatch(notificationsErrorShow(err.data));
  }
  if (response && response.data.twoFactorToken) {
    dispatch(getApiSetAppTwoFa(true));
    return response;
  }

  if (response && response.data.emailSent) {
    dispatch(getApiSetEmailTwoFa(true));
    return response;
  }

  if (response && response.data.codeSent) {
    dispatch(getApiSetPhoneTwoFa(true));
    return response;
  }

  if (response && response.data) {
    dispatch(getMerchantApiKeysSuccess(response.data));
    return response;
  }

  dispatch(getMerchantApiKeysFail());
};

export const getWebhooksListRequest = () => ({
  type: GET_WEBHOOKS_LIST_REQUEST
});

export const getWebhooksListSuccess = payload => ({
  type: GET_WEBHOOKS_LIST_SUCCESS,
  payload
});

export const getWebhooksListFail = payload => ({
  type: GET_WEBHOOKS_LIST_FAIL,
  payload
});

export const getWebhooksList = dispatch => async (merchantId, params) => {
  dispatch(getWebhooksListRequest());

  try {
    const response = await cryptoApi.getWebhooksList(merchantId, params);
    dispatch(getWebhooksListSuccess(response.data));
  } catch (error) {
    dispatch(getWebhooksListFail(error?.data));
    dispatch(notificationsErrorShow(error?.data));
  }
}
